export enum ProductKeyEnum {
  INTELLIGENCE = "intelligence",
  TARGETIN = "targetin"
}
export type ProductKey = ProductKeyEnum;

export type Product = {
  key: ProductKey;
  label: string;
  url: string;
};

export const DEFAULT_PRODUCT: ProductKey = ProductKeyEnum.INTELLIGENCE;

export const PRODUCTS: Product[] = [
  {
    key: ProductKeyEnum.TARGETIN,
    label: "Targetin",
    url: import.meta.env.VITE_TARGETIN_APP_URL ?? ""
  },
  {
    key: ProductKeyEnum.INTELLIGENCE,
    label: "Intelligence",
    url: import.meta.env.VITE_APP_URL ?? ""
  }
];
